export interface InbodyUsedItem {
  title: string;
  bgPath: string;
  href: string;
}

export const inbodyUsedList: InbodyUsedItem[] = [
  {
    title: "menu.learn.medical",
    bgPath: "/main/inbody-used/Medical.png",
    href: "/learn/medical",
  },
  {
    title: "menu.learn.fitness",
    bgPath: "/main/inbody-used/Fitness.jpeg",
    href: "/learn/fitness",
  },
  {
    title: "menu.learn.pharmacy",
    bgPath: "/main/inbody-used/1.jpg",
    href: "/learn/pharmacy",
  },
  {
    title: "menu.learn.aesthetic",
    bgPath: "/main/inbody-used/2.jpg",
    href: "/learn/aesthetic",
  },
  {
    title: "menu.learn.corporate",
    bgPath: "/main/inbody-used/Corporate.jpeg",
    href: "/learn/corporate",
  },
];
